import { render, staticRenderFns } from "./SaldoTableCuentas.vue?vue&type=template&id=bbe4c782&"
import script from "./SaldoTableCuentas.vue?vue&type=script&lang=js&"
export * from "./SaldoTableCuentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports